export default __webpack_public_path__ + "f48fcd57e64c3cccb2d226b309033088.jpg";